import type { LinkHubCustomerState } from '../types/ReducerTypes';

export const INIT_STATE: LinkHubCustomerState = {
  adLinks: {
    showLegacy: false,
  },
  quickLinks: {
    showLegacy: false,
  },
};
